import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UbicarComponent } from './ubicar/ubicar.component';
import { UbicarService } from './ubicar.service';
import { MaterialModule } from '../material.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MapaBaseComponent } from '../mapbox/mapa-base/mapa-base.component';

@NgModule({
  declarations: [UbicarComponent],
  imports: [CommonModule, MaterialModule, DragDropModule, MapaBaseComponent],
  providers: [UbicarService],
})
export class UbicarModule {}
